import { memo } from 'react';

import { DropdownMenu, type DropdownMenuProps } from '@air/primitive-dropdown-menu';

import { agentDropdownMenuPanel } from '~/components/v2/components/private-selection-bar/agent-selection-bar/agent-dropdown-menu/agentDropdownMenuVariants';

export type AgentDropdownMenuProps = DropdownMenuProps;

/**
 * Agent selection bar dropdown — dark glass panel over `@air/primitive-dropdown-menu`.
 * Literal white-on-glass tokens (not theme semantic grays) because menu content is portaled
 * outside the bar's `data-theme` context. Matches #8966 selection-list panel chrome.
 */
export const AgentDropdownMenu = memo(
  ({ className, side = 'top', sideOffset = 16, ...props }: AgentDropdownMenuProps) => (
    <DropdownMenu
      className={agentDropdownMenuPanel({ className })}
      data-theme="dark"
      side={side}
      sideOffset={sideOffset}
      {...props}
    />
  ),
);

AgentDropdownMenu.displayName = 'AgentDropdownMenu';
